import { User, Users, Goal, Sun, Calendar, CreditCard, UserCheck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { PackageInfo } from "@/components/PackageInfo";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const services = [
  {
    icon: User,
    title: "Einzeltraining Kind",
    price: "40€",
    unit: "pro 60 Min",
    description: "Intensives 1:1 Training für Kinder & Jugendliche",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
  },
  {
    icon: UserCheck,
    title: "Einzeltraining Erwachsen",
    price: "50€",
    unit: "pro 60 Min",
    description: "Intensives 1:1 Training für Erwachsene",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
  },
  {
    icon: Users,
    title: "Gruppentraining",
    price: "30€",
    unit: "2-4 Spieler",
    description: "Kleingruppentraining für gemeinsames Lernen",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
  },
  {
    icon: Users,
    title: "Gruppentraining",
    price: "20€",
    unit: "ab 5 Spieler",
    description: "Preisgünstig für größere Gruppen",
    span: "col-span-12 md:col-span-6 lg:col-span-6",
  },
  {
    icon: Goal,
    title: "Torwarttraining",
    price: "40€",
    unit: "pro 60 Min",
    description: "Spezielles Training für Torhüter",
    span: "col-span-12 md:col-span-6 lg:col-span-6",
  },
  {
    icon: Sun,
    title: "Sonntagstraining",
    price: "20€",
    unit: "pro Spieler",
    description: "Wöchentliches Gruppentraining, So 10:45-12:00",
    span: "col-span-12 md:col-span-6 lg:col-span-6",
  },
  {
    icon: Calendar,
    title: "Feriencamps",
    price: "Auf Anfrage",
    unit: "",
    description: "Intensives Training in den Schulferien",
    span: "col-span-12 md:col-span-6 lg:col-span-6",
    featured: true,
  },
];



export const ServicesSection = () => {
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/appointments/training-types`)
      .then((r) => r.json())
      .then((d) => setPackages(d.packages || []))
      .catch(() => setPackages([]));
  }, []);

  return (
    <section
      id="leistungen"
      className="services-section py-20 lg:py-32 relative"
      data-testid="services-section"
    >
      <div className="grid-lines absolute inset-0 opacity-50" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-[#c1ff72] font-semibold mb-4">
            Unsere Angebote
          </p>
          <h2 className="font-['Bebas_Neue'] text-4xl md:text-6xl lg:text-7xl uppercase tracking-tighter text-white">
            TRAININGS<span className="text-[#c1ff72]">LEISTUNGEN</span>
          </h2>
          <p className="text-[#A1A1AA] mt-4 max-w-xl text-lg">
            Ab 6 Jahre bis Erwachsene – für jedes Level das passende Training
          </p>
        </div>

        {/* Services Bento Grid */}
        <div className="grid grid-cols-12 gap-4 lg:gap-6 mb-16" data-testid="services-grid">
          {services.map((service) => (
            <div
              key={service.title}
              className={`${service.span} bento-item group cursor-pointer ${
                service.featured ? "border-[#c1ff72]/50" : ""
              }`}
              data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 bg-[#c1ff72]/10 flex items-center justify-center group-hover:bg-[#c1ff72]/20 transition-colors duration-300">
                  <service.icon className="w-6 h-6 text-[#c1ff72]" />
                </div>
                {service.featured && (
                  <span className="package-badge">FERIENSPECIAL</span>
                )}
              </div>
              
              <h3 className="font-['Bebas_Neue'] text-2xl md:text-3xl text-white mb-2 tracking-tight">
                {service.title}
              </h3>
              
              <div className="flex items-baseline gap-2 mb-4">
                <span className="font-['Bebas_Neue'] text-4xl text-[#c1ff72]">
                  {service.price}
                </span>
                {service.unit && (
                  <span className="text-[#71717A] text-sm">{service.unit}</span>
                )}
              </div>
              
              <p className="text-[#A1A1AA] text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Packages Section */}
        <div id="preise" className="mt-20 scroll-mt-24">
          <div className="flex items-center gap-4 mb-8">
            <CreditCard className="w-6 h-6 text-[#c1ff72]" />
            <h3 className="font-['Bebas_Neue'] text-3xl md:text-4xl text-white tracking-tight">
              SPARPAKETE & ABOS
            </h3>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="packages-grid">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className={`pricing-card ${pkg.id === "10er_karte" ? "border-[#c1ff72] featured" : "border-[#c1ff72]/30"}`}
                data-testid={`package-card-${pkg.id}`}
              >
                <h4 className="font-['Bebas_Neue'] text-2xl text-white mb-2">
                  {pkg.name}
                </h4>
                <PackageInfo pkg={pkg} />
              </div>
            ))}
          </div>
          
          {/* CTA Button */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/buchen"
              className="inline-flex items-center justify-center gap-2 bg-[#c1ff72] text-[#0A0A0A] px-8 py-4 font-semibold hover:bg-[#a8e65c] transition-colors"
              data-testid="btn-book-now"
            >
              JETZT ONLINE BUCHEN
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/pakete"
              className="inline-flex items-center justify-center gap-2 border border-[#c1ff72] text-[#c1ff72] px-8 py-4 font-semibold hover:bg-[#c1ff72]/10 transition-colors"
              data-testid="btn-view-packages"
            >
              SPARPAKET KAUFEN
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
